import * as Animate from "react-reveal";
import GroupSubNav from "../../../components/layout/GroupSubNav";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import { ArrowUpRight } from "../../../components/svgs";
import TeamImg from "../../../assets/images/png/african-tech-team.webp";

const AboutHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      style={{ backgroundImage: "linear-gradient(#fff 0%, #f7f9ff 100%)" }}
    >
      <HeaderNavigation />
      <GroupSubNav />

      <div className="container mx-auto px-4 py-14 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-12 lg:gap-10">
          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
                <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
                About Utiva
              </p>

              <h1 className="text-4xl md:text-5xl lg:text-7xl font-poppins tracking-[-0.03em] leading-[1.05] font-black mb-7">
                <span className="text-primary block">
                  Talent is everywhere.
                </span>
                <span className="text-default block">
                  Opportunity should be too.
                </span>
              </h1>

              <p className="font-poppins text-lg md:text-xl text-gray leading-relaxed mb-9 max-w-xl">
                Utiva is a connected platform for building skills and building
                teams. We help ambitious people develop practical technology and
                business capabilities—and help companies discover, hire, manage
                and pay talent from emerging markets.
              </p>

              <div className="flex flex-wrap font-poppins items-center gap-5 md:gap-7 text-base md:text-lg mb-6">
                <a
                  href="/school"
                  className="text-white bg-primary font-poppins custom-btn px-8 py-4 text-center rounded-xl inline-flex items-center font-bold shadow-course-feature focus:outline-none"
                >
                  Explore learning
                  <span className="ml-2">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </a>
                <a
                  href="/hire"
                  className="text-primary text-base font-poppins font-bold underline decoration-secondary decoration-2 underline-offset-4 hover:opacity-80 transition-all"
                >
                  Build your team →
                </a>
              </div>

              <p className="border-l-4 border-secondary pl-4 text-default font-poppins text-sm font-bold">
                One connected journey across learning, hiring and global work.
              </p>
            </Animate.Fade>
          </div>

          <div className="w-full lg:col-span-6">
            <Animate.Fade bottom>
              <div
                className="relative rounded-3xl overflow-hidden shadow-course-feature-lg"
                style={{ minHeight: "600px" }}
              >
                <img
                  src={TeamImg}
                  alt="A Utiva team collaborating"
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div
                  className="absolute inset-x-0 bottom-0"
                  style={{
                    height: "55%",
                    background:
                      "linear-gradient(transparent, rgba(3,4,71,0.92))",
                  }}
                ></div>

                <div className="absolute top-5 right-5 z-10 w-11/12 sm:w-64 bg-white/95 backdrop-blur rounded-2xl p-4 shadow-course-feature">
                  <strong className="text-primary font-poppins font-extrabold text-base block mb-1">
                    Since 2018
                  </strong>
                  <span className="text-gray font-poppins text-xs">
                    Learning → Talent → Global work
                  </span>
                </div>

                <div className="absolute z-10 bottom-7 left-7 right-7 font-poppins">
                  <p className="text-secondary text-xs font-extrabold tracking-widest uppercase mb-2">
                    Our purpose
                  </p>
                  <h2 className="text-white text-xl md:text-2xl font-poppins font-extrabold leading-tight">
                    Build capability. <br />
                    Create access. <br />
                    Move people forward.
                  </h2>
                </div>
              </div>
            </Animate.Fade>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AboutHeaderSection;
